import Approve from './Approve'
import AssignModerator from './AssignModerator'
import ChangeAuthor from './ChangeAuthor'
import CloseTopic from './CloseTopic'
import MarkAsNotSpam from './MarkAsNotSpam'
import MarkAsSpam from './MarkAsSpam'
import MarkAsReadByTeam from './MarkAsReadByTeam'
import { createMoveToComponent } from './MoveTo'
import PermanentlyDelete from './PermanentlyDelete'
import TrashTopic from './TrashTopic'
import Resolve from './Resolve'
import Restore from './Restore'
import EmptyTrash from './EmptyTrash'

export {
  Approve,
  AssignModerator,
  ChangeAuthor,
  CloseTopic,
  MarkAsNotSpam,
  MarkAsSpam,
  MarkAsReadByTeam,
  createMoveToComponent,
  PermanentlyDelete,
  TrashTopic,
  Resolve,
  Restore,
  EmptyTrash
}
